/**
 * CloseIcon Component
 * 
 * Custom close/X icon for modals, dialogs, and dismissible elements.
 */

import React from 'react';
import type { IconProps } from './types';

const CloseIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.001 5L19 19M5 19L18.999 5"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CloseIcon;
